import FormCondominios from "../FormCondominios/FormCondominios";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroCondominios.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import CondominioService from "../../../services/CondominioService";

const CadastroCondominios = () => {
	const { condominioId } = useParams();
	const { state } = useLocation();
	const [condominio, setCondominio] = useState(state);
	const [type, setType] = useState("");

	async function loadCondominio(id) {
		const response = await CondominioService.getOne(id);
		if (response.data) {
			setCondominio(response.data);
		}
	}

	useEffect(() => {
		const action = !state?.parentUnitId && (condominioId || state?.id) ? "edicao" : "cadastro";
		setType(action);
		if (action === "edicao" && condominioId) {
			loadCondominio(condominioId);
		}
	}, [state, condominioId]);

	return (
		<CadastroContainer>
			<FormCondominios condominio={condominio} type={type} parentUnitId={state?.parentUnitId} />
		</CadastroContainer>
	);
};

export default CadastroCondominios;